import { createFileRoute } from '@tanstack/react-router';
import { AllTasksPage } from '@/features/work/ui/AllTasksPage';

export const Route = createFileRoute('/_authenticated/work/tasks')({ component: () => <AllTasksPage /> });
